export const ApiConfig = {
  auth: {
    login: "auth/login",
    resetPassword: "auth/reset-password",
    forgotPassword: "auth/forgot-password",
    register: "auth/player/register",
    verifyEmail: "auth/verify-account",
    logout: "auth/logout",
  },
  dashboard: {
    info: '/dashboard',
    stats: '/dashboard/player-stats',
    logs: '/dashboard/game-logs'
  },
  profile: {
    load: "profile",
    update: "profile/update",
    updatePic: 'profile/update-profile-pic',
    changePassword: "profile/change-password",
  },
  player: {
    teams: 'player/teams',
    leagues: 'leagues',
    playerSearch: 'player/teams/player-search',
    addPlayer: 'player/teams/team_id/add-player',
    updatePlayer: 'player/teams/team_id/update-player',
    removePlayer: 'player/teams/team_id/remove-player',
    invites: 'player/invites',
    registrations: {
      registered: 'player/registrations',
      registeredWithConfirm: 'player/registrations/register-confirm',
      upcoming: 'player/registrations/upcoming'
    }
  },
  courts: "/courts",
  matches: {
    list: 'matches',
    newlist: 'matches/newlist',
    matchLogs: 'matches/logs',
    quickMatchCreateDetails: 'matches/quick-match-details',
    updateScorer: 'matches/update-scorer',
    updateScorerStatus: 'matches/update-scorer-status',
    updateScorerManager: 'matches/update-scorer-manager',
    updateDetails: 'matches/update-details',
    updateDetailsManager: 'matches/update-details-manager',
    updateMatch: 'matches/update-match',
    updateMatchManager: 'matches/update-match-manager',
    updateScheduledMatch: 'matches/update-scheduled-match',
    updateScheduledMatchNew: 'matches/update-scheduled-matchnew',
    startMatch: 'matches/start-match',
    startMatchNew: 'matches/start-match-new',
    startMatchManager: 'matches/start-match-manager',
    jerseyViolationManager: 'matches/jersey-violation-manager',
    addPlayers: 'matches/add-players',
    addPlayerToTeam: 'matches/add-player-to-team',
    updateMatchScore: 'matches/update-score',
    updateMatchScoreManager: 'matches/update-score-manager',
    getScorer: 'matches/scorer',
    getScorermanager: 'matches/scorermanager',
    downloadSampleFile: 'matches/game-creation-file',
    lastUploadHistory: 'matches/last-upload-history',
    updatednp: 'matches/updatednp'
  },
  users: '/users',
  userInfo: {
    count: 'users/count'
  },
  leagues: '/leagues',
  seasons: '/seasons',
  season: {
    updateTierForRegisteredTeam: '/seasons/update-registerd-team-tier',
    removeRegisteredTeamFromTier: '/seasons/remove-registerd-team-tier'
  },
  common: {
    statFields: '/settings/stat-fields',
    UpdateLeagueFees: '/settings/leaguefees',
    getInfo: '/settings/getinfo',
    getFilters: '/settings/getfilters',
    leaguesList: '/settings/leagueslist',
    getMatchesinList: '/settings/getMatchesinList',
    updatenewspage: '/settings/update-newspage',
    getnewspage: '/settings/newspage',
    getScoreByMatch: 'settings/scorer',
    list: 'settings',
    playerSearch: 'settings/player-search',
    addPlayerToTeam: 'settings/add-player-to-team',
    startMatch: 'settings/start-match',
    getmatchesdate: 'settings/getmatchesdate',
    getcourts:'settings/courts',
    fetchplayers:'settings/fetchplayers',
  },
  website: {
    getaccountsettings: '/settings/getaccountsettings',
    getWebsiteInfo: '/settings/getwebsiteinfo',
    saveWebsiteInfo: '/settings/savewebsiteinfo',
    updateWebsiteInfo: '/settings/updatewebsiteinfo',
    deleteWebsiteInfo: '/settings/deletewebsiteinfo',
    savePromotionImage: '/settings/saveimage',
  },
  marketing: {
    sendEmailCampaign: '/marketing/create-campaign',
    list: '/marketing/getlist',
    deletecampaign: '/marketing/delete',
    deletedraftcampaign: '/marketing/deletedraft',
  }
}

export default ApiConfig;